// Private-link installs sit on `<tenant>.privatelink.celerdata.com` instead of
// `<tenant>.celerdata.com`. The API base URL must follow the same subdomain
// so cookies + CORS line up — `parsePrivateLink` swaps `celerdata.com` for
// `privatelink.celerdata.com` when the page itself is on the private domain.

const SECOND_DOMAIN = 'celerdata.com';
const PRIVATE_THIRD_DOMAIN = 'privatelink.celerdata.com';

export const isPrivateLink = (): boolean => {
  return location.host.includes(PRIVATE_THIRD_DOMAIN);
};

export const parsePrivateLink = (link: string | undefined): string => {
  if (link && isPrivateLink()) {
    return link.replace(SECOND_DOMAIN, PRIVATE_THIRD_DOMAIN);
  }
  return link ?? '';
};

// Unguarded form, for the public-domain caller that builds the URL to bounce
// to — `parsePrivateLink` returns the href unchanged there.
export const toPrivateLinkHref = (href: string): string => {
  return href.includes(PRIVATE_THIRD_DOMAIN)
    ? href
    : href.replace(SECOND_DOMAIN, PRIVATE_THIRD_DOMAIN);
};
